import React, { FC, useMemo } from "react";
import { StyleProp, TextStyle, ViewStyle } from "react-native";
import { Image, View, useDevice } from "@lookiero/aurora";
import { Text } from "@lookiero/sty-psp-ui";
import { style as stackedBannerStyle } from "./StackedBanner.style";

interface StackedBannerStyle {
  readonly wrapper: StyleProp<ViewStyle>;
  readonly title: StyleProp<TextStyle>;
}

interface StackedBannerProps {
  readonly title: string;
  readonly subtitle: string;
  readonly imageUrl: string;
  readonly style?: Partial<StackedBannerStyle>;
  readonly onImageError?: () => void;
}

const StackedBanner: FC<StackedBannerProps> = ({ title, subtitle, imageUrl, style: customStyle, onImageError }) => {
  const { screen } = useDevice();

  const style = useMemo(() => stackedBannerStyle(), []);

  return imageUrl ? (
    <View style={[screen.L ? style.wrapperLarge : style.wrapperSmall, customStyle?.wrapper]}>
      <View style={style.contentWrapper}>
        <Text level={3} style={[style.title, customStyle?.title]} variant={screen.L ? "action" : "heading"}>
          {title}
        </Text>

        <Text level={screen.L ? 1 : 2} style={style.subtitle} variant="detail">
          {subtitle}
        </Text>
        <Image resizeMode="contain" src={imageUrl} style={style.image} onError={onImageError} />
      </View>
    </View>
  ) : null;
};

export { StackedBanner };
